import { color, Text, VStack } from '@starrez/starryui9';
import React from 'react';
import styled from 'styled-components';
import { useManagedDropdown } from '../../ManagedDropdown/ManagedDropdown';
import { SearchInput } from '../../SearchInput/SearchInput';
import { Tree } from '../Tree';
import { ITreeData } from '../Tree/types';
import { useProps } from './FolderDropdown';
import { NodeRender } from './NodeRender';

export const Dropdown = () => {
    const { nodes, onSelectItem, allowSearch, allowCreateNewFolder, onCreateNewFolderClick, onSearch, value } = useProps();
    const { closeDropdown } = useManagedDropdown();

    const handleItemClick = (item: ITreeData) => {
        onSelectItem(item);
        closeDropdown();
    };

    const handleSearch = (search: string) => {
        return new Promise<void>((resolve) => {
            onSearch(search);
            resolve();
        });
    };

    // TODO fix this in a future commit
    if (value && nodes) {
        const selectedItem = nodes.find((e) => e.id === value.id);
        if (selectedItem) {
            selectedItem.isSelected = true;
        }
    }

    return (
        <VStack rows="auto">
            {allowSearch && <SearchInput clearAriaLabel="" onSearchChange={handleSearch} placeholder="Search" searchAriaLabel="" />}
            <div style={{ height: '340px', padding: '2px', overflowX: 'auto' }}>
                <Tree node={NodeRender} onSelect={handleItemClick} data={nodes} />
            </div>
            {allowCreateNewFolder && (
                <FooterButton type="button"  onClick={onCreateNewFolderClick}>
                    <Text>Create New Folder</Text>
                </FooterButton>
            )}
        </VStack>
    );
};

const FooterButton = styled.button`
    height: 40px;
    background: transparent;
    border: 0;
    border-top: 1px solid ${color.Grey.G30};
    text-align: left;
    padding: 0 16px;
    cursor: pointer;
`;
